import React from 'react';
import WheelAdminOverview from '@/components/admin/wheel/WheelAdminOverview';

const AdminWheelPage: React.FC = () => {
  return <WheelAdminOverview />;
};

export default AdminWheelPage;
